"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JwtCheckService = void 0;
const jsonwebtoken_1 = require("jsonwebtoken");
const AuthTokenErrorHandleService_1 = require("./AuthTokenErrorHandleService");
class JwtCheckService {
    static decode(token) {
        return (0, jsonwebtoken_1.decode)(token);
    }
    static verify(token, key) {
        try {
            return (0, jsonwebtoken_1.verify)(token, key);
        }
        catch (error) {
            throw AuthTokenErrorHandleService_1.AuthTokenErrorHandleService.generateError(error);
        }
    }
}
exports.JwtCheckService = JwtCheckService;
//# sourceMappingURL=JwtCheckService.js.map